<template>
    <div>
        <mainindex>
            <div v-if="!islogmode" class="content">
                <!--<div class="content" v-if="gen._UID && !islogmode">-->
                <!--HEADER-->
                <page-header v-if="mode !== 'home' && mode !== 'startprj'" :cur-page="mode" :menu-tree="menu" @nav="go($event)" @openlogspanel="toggleLogsPanel" @save-prj="savePrj()" @clone-prj="cloneProject()" @new-prj="newPrj"></page-header>
                <!--HEADER-->
                <!--BODY-->
                <div :class="[paddingClass]" class="body">
                    <router-view v-if="$route.name !== null"></router-view>
                    <!--<div>{{$route.name}}</div>-->
                    <template v-if="mode === 'home' && $route.name !== 'resetPassword'">
                        <home @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects')"></home>
                    </template>
                    <template v-else-if="mode === 'startprj'">
                        <start-prj @nav="go($event)"></start-prj>
                    </template>
                    <template v-else-if="mode === 'projects'">
                        <div class="container-fluid">
                            <div v-if="user.seller > 3" class="mb-3">
                                <notifications></notifications>
                            </div>
                            <b-tabs content-class="">
                                <!--My View-->
                                <b-tab :title="_trans('My View')" active>
                                    <div>
                                        <prj-finder
                                            :cols="[
                                                { id: 'id', title: 'id', order: 0 },
                                                { id: 'info', title: _trans('reference'), order: 7 },
                                                { id: 'status', title: _trans('status'), order: 4 },
                                                { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                { id: 'shopdes', title: _trans('shop') },
                                                { id: 'usermail', title: _trans('user') },
                                                { id: 'ownermail', title: _trans('owner') },
                                                { id: 'open', title: null },
                                                { id: 'viewoffer', title: null },
                                                { id: 'send', title: null },
                                                { id: 'order', title: null },
                                                { id: 'download', title: null },
                                                { id: 'production', title: null },
                                                { id: 'delete', title: null },
                                                { id: 'close', title: null }
                                            ]"
                                            :rows-number="10"
                                            :title="_trans('My projects')"
                                            filter="MY"
                                            order-by="11D"
                                            @open="openPrj($event)"
                                            @viewoffer="viewOffer($event)"
                                        ></prj-finder>
                                        <div v-if="user.seller > 1">
                                            <prj-finder
                                                :cols="[
                                                    { id: 'id', title: 'id', order: 0 },
                                                    { id: 'info', title: _trans('reference'), order: 7 },
                                                    { id: 'status', title: _trans('status'), order: 4 },
                                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                    { id: 'shopdes', title: _trans('shop') },
                                                    { id: 'usermail', title: _trans('user') },
                                                    { id: 'ownermail', title: _trans('owner') },
                                                    { id: 'open', title: null },
                                                    { id: 'viewoffer', title: null },
                                                    { id: 'send', title: null },
                                                    { id: 'order', title: null },
                                                    { id: 'download', title: null },
                                                    { id: 'production', title: null },
                                                    { id: 'delete', title: null },
                                                    { id: 'close', title: null }
                                                ]"
                                                :rows-number="10"
                                                :title="_trans('Involved')"
                                                filter="INVOLVED"
                                                order-by="11D"
                                                @open="openPrj($event)"
                                                @viewoffer="viewOffer($event)"
                                            ></prj-finder>
                                        </div>
                                    </div>
                                </b-tab>
                                <!--Existing Projects-->
                                <b-tab v-if="user.seller > 1" :title="_trans('Existing Projects')">
                                    <div>
                                        <prj-finder
                                            :cols="[
                                                { id: 'id', title: 'id', order: 0 },
                                                { id: 'info', title: _trans('reference'), order: 7 },
                                                { id: 'status', title: _trans('status'), order: 4 },
                                                { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                { id: 'shopdes', title: _trans('shop') },
                                                { id: 'usermail', title: _trans('user') },
                                                { id: 'ownermail', title: _trans('owner') },
                                                { id: 'open', title: null },
                                                { id: 'assign', title: null }
                                            ]"
                                            :rows-number="10"
                                            :title="_trans('Other projects in my store')"
                                            filter="OTHERPRJ"
                                            order-by="11D"
                                            @open="openPrj($event)"
                                            @viewoffer="viewOffer($event)"
                                        ></prj-finder>
                                        <div v-if="user.seller >= 5">
                                            <prj-finder
                                                :cols="[
                                                    { id: 'id', title: 'id', order: 0 },
                                                    { id: 'info', title: _trans('reference'), order: 7 },
                                                    { id: 'status', title: _trans('status'), order: 4 },
                                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                    { id: 'shopdes', title: _trans('shop') },
                                                    { id: 'usermail', title: _trans('user') },
                                                    { id: 'ownermail', title: _trans('owner') },
                                                    { id: 'open', title: null },
                                                    { id: 'assign', title: null }
                                                ]"
                                                :rows-number="10"
                                                :title="_trans('Unassigned projects')"
                                                filter="UNASSIGNED"
                                                order-by="11D"
                                                @open="openPrj($event)"
                                                @viewoffer="viewOffer($event)"
                                            ></prj-finder>
                                        </div>
                                    </div>
                                </b-tab>
                                <!--Unassigned-->
                                <b-tab v-if="user.seller > 1" :title="_trans('Projects Unassigned')">
                                    <div>
                                        <prj-finder
                                            :cols="[
                                                { id: 'id', title: 'id', order: 0 },
                                                { id: 'info', title: _trans('reference'), order: 7 },
                                                { id: 'status', title: _trans('status'), order: 4 },
                                                { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                { id: 'shopdes', title: _trans('shop') },
                                                { id: 'usermail', title: _trans('user') },
                                                { id: 'ownermail', title: _trans('owner') },
                                                { id: 'open', title: null },
                                                { id: 'assign', title: null }
                                            ]"
                                            :rows-number="10"
                                            :title="_trans('Projects Unassigned')"
                                            filter="UNASSIGNED"
                                            order-by="11D"
                                            @open="openPrj($event)"
                                            @viewoffer="viewOffer($event)"
                                        ></prj-finder>
                                    </div>
                                </b-tab>
                                <!--Closed/Deleted-->
                                <b-tab v-if="user.seller > 3" :title="_trans('Closed/Deleted')">
                                    <div>
                                        <prj-finder
                                            :cols="[
                                                { id: 'id', title: 'id', order: 0 },
                                                { id: 'info', title: _trans('reference'), order: 7 },
                                                { id: 'status', title: _trans('status'), order: 4 },
                                                { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                { id: 'shopdes', title: _trans('shop') },
                                                { id: 'usermail', title: _trans('user') },
                                                { id: 'ownermail', title: _trans('owner') }
                                            ]"
                                            :rows-number="10"
                                            :title="_trans('Closed projects')"
                                            filter="CLOSED"
                                            order-by="11D"
                                            @open="openPrj($event)"
                                            @viewoffer="viewOffer($event)"
                                        ></prj-finder>
                                        <prj-finder
                                            :cols="[
                                                { id: 'id', title: 'id', order: 0 },
                                                { id: 'info', title: _trans('reference'), order: 7 },
                                                { id: 'status', title: _trans('status'), order: 4 },
                                                { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                { id: 'shopdes', title: _trans('shop') },
                                                { id: 'usermail', title: _trans('user') },
                                                { id: 'ownermail', title: _trans('owner') },
                                                { id: 'assign', title: null }
                                            ]"
                                            :rows-number="10"
                                            :title="_trans('Deleted projects')"
                                            filter="INACTIVE"
                                            order-by="11D"
                                            @open="openPrj($event)"
                                            @viewoffer="viewOffer($event)"
                                        ></prj-finder>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </template>
                    <template v-else-if="mode === 'notifications'">
                        <notifications></notifications>
                    </template>
                    <template v-else-if="mode === 'itemsearch'">
                        <article-search @nav="go($event)"></article-search>
                    </template>
                    <template v-else-if="mode === 'renders'">
                        <renders @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'configurator'">
                        <configure :update-picture="false" @nav="go($event)"></configure>
                    </template>
                    <template v-else-if="mode === '3dview' || mode === 'planner'">
                        <view3d :load-header-on-start="true" @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === '2dview'">
                        <view2d :load-header-on-start="true" @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'compositions'">
                        <compositions :apply-header="true" @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'offerview'">
                        <offer @nav="go($event)"></offer>
                    </template>
                    <template v-else-if="mode === 'summary'">
                        <prj-summary @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'customerinfo'">
                        <customer-info @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'prjlog'">
                        <prj-log @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'delivery'">
                        <delivery @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'promotions'">
                        <promotions @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'myprofile'">
                        <my-profile @nav="go($event)" />
                    </template>
                    <template v-else-if="mode === 'json'">
                        <d-json :value="prj" />
                    </template>
                    <template v-else>
                        <h1 v-if="$route.name === null">::::{{ mode }}::::</h1>
                    </template>
                </div>
                <!--BODY-->
            </div>
            <home v-else @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects.my')"></home>
        </mainindex>
        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>
        <b-alert v-if="isMaintenanceBooked || isMaintenance" class="position-fixed fixed-bottom m-0 rounded-0" show style="z-index: 2000" variant="warning">
            <span>
                <span v-text="_trans('Maintenance from')"></span>
                <span v-text="startDate"></span>
                <span v-text="_trans('to')"></span>
                <span v-text="endDate"></span>
            </span>
        </b-alert>
        <b-modal v-if="isMaintenance && $store.state.commonStore.profile" ref="modal" :title-html="_trans('Maintenance')" centered hide-footer size="xl" variant="warning" visible>
            <template v-slot:modal-header-close>
                <b-button class="ni ni-close" size="sm" variant="primary" @click="close()"></b-button>
            </template>
            <div class="py-5 px-3 text-center">
                <h1>
                    <span v-text="_trans('Maintenance mode active')"></span>
                    <!--<span v-text="startDate"></span>-->
                    <!--<span v-text="_trans('to')"></span>-->
                    <!--<span v-text="endDate"></span>-->
                </h1>
                <div v-if="$store.state.commonStore.profile.admin" class="d-flex justify-content-center mt-4">
                    <b-btn variant="secondary" @click="unlockManteinance" v-text="_trans('Unlock maintenance')"></b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import "../../../scss/progeo.scss";
    import { App, CsearchAPI, InsertItem2D, PopVariant, ResolveForcedVars, RevalPrj } from "@3cad/nextcore";
    import { bus } from "@store/dau";
    import NextModals from "@dialogs/index";
    import { V_ModalDClass, V_ModalPopVar } from "@vuectrls/controllers.js";

    import index from "@configurator/index";

    export default {
        mixins: [index],
        data() {
            return {
                menu: require("@assets/progeo/json/menu.json"),
                routingKeys: null
            };
        },
        computed: {
            paddingClass() {
                switch (this.mode) {
                    case "home":
                    case "startprj":
                    case "itemsearch":
                    case "projects":
                        return "mid-menu";
                    default:
                        return "mid-menu";
                }
            },
            canSavePrj() {
                if (this.prj) {
                    const status = this.prj.status;
                    return status !== "ORDERED" && status !== "INPRODUCTION";
                } else {
                    return true;
                }
            },
            startDate() {
                if (this.$store.state.commonStore.maintenance.startDateTimeUTC) return this.$moment(this.$store.state.commonStore.maintenance.startDateTimeUTC).locale(this.datePickerFormat).format("LLL");
                else return null;
            },
            endDate() {
                if (this.$store.state.commonStore.maintenance.endDateTimeUTC) return this.$moment(this.$store.state.commonStore.maintenance.endDateTimeUTC).locale(this.datePickerFormat).format("LLL");
                else return null;
            }
        },
        watch: {
            user: {
                handler: function (newVal) {
                    // TODO: Guardare i seguenti link
                    // https://en.wikipedia.org/wiki/Language_localisation#Language_tags_and_codes
                    // http://www.rfc-editor.org/rfc/bcp/bcp47.txt#
                    // https://www.w3.org/International/articles/language-tags/
                    if (newVal.shop && (newVal.shop.country.toUpperCase() === "US" || newVal.shop.country.toUpperCase() === "CA" || newVal.shop.country.toUpperCase() === "GB" || newVal.shop.country.toUpperCase() === "UK" || newVal.shop.country.toUpperCase() === "EN")) {
                        this.preferences.config.measures.length = "EX";
                        this.preferences.config.measures.volume = "CI";
                        this.preferences.config.measures.weight = "LB";
                    } else {
                        this.preferences.config.measures.length = "MM";
                        this.preferences.config.measures.volume = "CR";
                        this.preferences.config.measures.weight = "KG";
                    }
                },
                deep: true
            }
        },
        beforeCreate() {
            this.$store.registerModule("progeo", {
                namespaced: true,
                state: {
                    progeoUserExtraDataHidePrices: null,
                    progeoHidePricesVisible: true,
                    progeoHidePrices: App.getConfig().config.progeoHidePrices,
                    progeoHideBom: App.getConfig().config.progeoHideBom,
                    progeoDiscount1: null,
                    progeoDiscount2: null,
                    progeoVat: null,
                    progeoShopDiscount: null
                }
            });
            // window.addEventListener('msgFromParent', this._messageFromParent);
        },
        methods: {
            async savePrj() {
                bus.$emit("startLoading", this._trans("Saving project"));
                if (this.preferences.config.saveprjpicture) {
                    try {
                        this.prj.img = await this.$store.dispatch("cad/projectPicture", { prj: this.prj });
                    } catch (e) {
                        console.error(e);
                    }
                }
                this.prj.customerFields.shopIdCleaned = this.prj.shopid ? this.prj.shopid.ex("_", 1) : this.user.shop.cod.ex("_", 1);
                return new Promise((resolve, reject) => {
                    if (this.canSavePrj) {
                        this.$store.dispatch("project/save", {}).then(res => {
                            this.$store.commit("resetLoading");
                            bus.$emit("savedPrj");
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            },
            _checkRouting() {
                if (this.$route.name === "entry" && this.$route.params) {
                    this.routingKeys = this.$route.params;
                    if (this.routingKeys) {
                        this.setNewProject(this.routingKeys.lang, this.routingKeys.catalog, this.routingKeys.model, this.routingKeys.item, this.routingKeys.variants);
                    }
                }
            },
            setNewProject(pLang, pCatalog, pModel, pItem, pVariants) {
                bus.$emit("startLoading");
                App.setLang(pLang)
                    .then(() => {
                        if (this.$store.state.searchArticle) {
                            this.$store.unregisterModule("searchArticle");
                        }

                        this.$store.commit("project/empty");
                        this.$store.commit("erp/reset");
                        // this.resetCustomerParams();
                        CsearchAPI.getModels(
                            pCatalog,
                            pModel,
                            null,
                            json => {
                                let insertItem = new InsertItem2D(App.getLoaderManager());
                                let modalVariant = new V_ModalPopVar(NextModals.popVariant);
                                let modalDclass = new V_ModalDClass(
                                    NextModals.popDclass,
                                    {
                                        size: "xl",
                                        dialogClass: "modal-full"
                                    },
                                    App.getConfig().dclass
                                );
                                let popVariant = new PopVariant(modalVariant, modalDclass, Object.keys(App.getConfig().dclass));
                                let forcedResolver = new ResolveForcedVars(popVariant);

                                let model = {
                                    des: json[0].des,
                                    cmodel: json[0].cod,
                                    cod: json[0].basemodel,
                                    header: ""
                                };
                                this.prj.pushHistory(pCatalog, model);

                                let params = {
                                    cod: `${pModel}${pItem}`,
                                    neutro: pItem,
                                    load: pVariants || ""
                                };

                                insertItem
                                    .insert({ item: params, side: null, skipBasket: false }, this.prj, App.getICad(), forcedResolver)
                                    .then(() => {
                                        // let row = this.prj.getCurrentRow();
                                        // console.log(JSON.parse(JSON.stringify(row.rule)));
                                        bus.$emit("stopLoading");
                                        this.prj.isopen = true;
                                        this.go("configurator");
                                    })
                                    .catch(err => {
                                        console.log("Error to insert item:", err);
                                    });
                            },
                            err => {
                                console.log("getModels error:", err);
                            }
                        );
                    })
                    .catch(err => {
                        throw err;
                    });
            },
            _messageFromParent(e) {
                if (!e.data.action) {
                    console.warn("Missing action");
                }

                let data = null;
                if (e.data.data !== undefined) {
                    data = e.data.data;
                } else {
                    data = e.data;
                }
                let action = e.data.action;

                switch (action) {
                    case "configure":
                        /*
                                      let example = {
                                          "action": "configure",
                                          "catalog": "VOIT",
                                          "model": "E1",
                                          "item": "VAREZS"
                                      };
                                      */

                        //Check catalog
                        if (!data.catalog) {
                            this.iframeCom.sendMsg({
                                status: 1,
                                msg: "missing catalog",
                                action: "configure"
                            });
                            return;
                        }
                        let iCatalog = data.catalog;
                        // Check model
                        if (!data.cmodel && !data.model) {
                            this.iframeCom.sendMsg({
                                status: 1,
                                msg: "missing model",
                                action: "configure"
                            });
                            return;
                        }
                        let iModel = data.cmodel || data.model;
                        // Check item
                        if (!data.item) {
                            this.iframeCom.sendMsg({
                                status: 1,
                                msg: "missing item",
                                action: "configure"
                            });
                            return;
                        }
                        let iItem = data.item;
                        // Get variant if exist
                        let iVariant = "";
                        if (data.variant) {
                            iVariant = data.variant;
                        }

                        if (this.$store.state.searchArticle) {
                            this.$store.unregisterModule("searchArticle");
                        }

                        this.$store.commit("project/empty");
                        this.$store.commit("erp/reset");
                        // this.resetCustomerParams();

                        CsearchAPI.getModels(
                            iCatalog,
                            iModel,
                            null,
                            json => {
                                let insertItem = new InsertItem2D(App.getLoaderManager());
                                let modalVariant = new V_ModalPopVar(NextModals.popVariant);
                                let modalDclass = new V_ModalDClass(
                                    NextModals.popDclass,
                                    {
                                        size: "xl",
                                        dialogClass: "modal-full"
                                    },
                                    App.getConfig().dclass
                                );
                                let popVariant = new PopVariant(modalVariant, modalDclass, Object.keys(App.getConfig().dclass));
                                let forcedResolver = new ResolveForcedVars(popVariant);

                                let model = {
                                    des: json[0].des,
                                    cmodel: json[0].cod,
                                    cod: json[0].basemodel,
                                    header: ""
                                };
                                this.prj.pushHistory(iCatalog, model);

                                let params = {
                                    cod: `${iModel}${iItem}`,
                                    neutro: iItem,
                                    load: iVariant
                                };

                                insertItem
                                    .insert({ item: params, side: null, skipBasket: false }, this.prj, App.getICad(), forcedResolver)
                                    .then(() => {
                                        // let row = this.prj.getCurrentRow();
                                        // console.log(JSON.parse(JSON.stringify(row.rule)));
                                        this.iframeCom.sendMsg({
                                            status: 0,
                                            msg: "item added correctly",
                                            action: "configure"
                                        });
                                        this.prj.isopen = true;
                                        this.go("configurator");
                                    })
                                    .catch(err => {
                                        this.iframeCom.sendMsg({
                                            status: 1,
                                            msg: err,
                                            action: "configure"
                                        });
                                    });
                            },
                            err => {
                                this.iframeCom.sendMsg({
                                    status: 1,
                                    msg: err,
                                    action: "configure"
                                });
                            }
                        );
                        break;
                    default:
                        console.log("Message from parent", e.data);
                        break;
                }
            },
            resetCustomerParams() {
                this.checkCustomerParams();
            },
            onNewProject() {
                // if (this.user.shop.img) this.prj.customerFields.shopImage = this.user.shop.img;
                // this.prj.customerFields.hidePrices = this.$store.state.progeo.progeoHidePrices;
                // if (this.$store.state.progeo.progeoDiscount1) this.prj.customerFields.discount1 = this.$store.state.progeo.progeoDiscount1;
                // if (this.$store.state.progeo.progeoDiscount2) this.prj.customerFields.discount2 = this.$store.state.progeo.progeoDiscount2;
                // if (this.$store.state.progeo.progeoVat) this.prj.customerFields.vat = this.$store.state.progeo.progeoVat;
                this.go("itemsearch");
            },
            onProjectLoaded(viewoffer = false) {
                this.revalProject().then(() => {
                    if ("shopImage" in this.prj.customerFields && "hidePrices" in this.prj.customerFields && "sellerInfo" in this.prj.customerFields && "shopIdCleaned" in this.prj.customerFields && "discount1" in this.prj.customerFields && "discount2" in this.prj.customerFields && "vat" in this.prj.customerFields && "netElementPrice" in this.prj.customerFields) {
                        // customerFields già presente
                        if (viewoffer) this.go("summary");
                        else this.go("offerview");
                    } else {
                        this.checkCustomerParams();
                        if (this.user.shop.img) this.prj.customerFields.shopImage = this.user.shop.img;
                        this.prj.customerFields.hidePrices = this.$store.state.progeo.progeoHidePrices;
                        if (this.$store.state.progeo.progeoDiscount1) this.prj.customerFields.discount1 = this.$store.state.progeo.progeoDiscount1;
                        if (this.$store.state.progeo.progeoDiscount2) this.prj.customerFields.discount2 = this.$store.state.progeo.progeoDiscount2;
                        if (this.$store.state.progeo.progeoVat) this.prj.customerFields.vat = this.$store.state.progeo.progeoVat;
                        if (viewoffer) this.go("summary");
                        else this.go("offerview");
                    }
                });
            },
            checkCustomerParams() {
                if (!("shopImage" in this.prj.customerFields)) this.$set(this.prj.customerFields, "shopImage", this.user.shop.img || null);
                if (!("hidePrices" in this.prj.customerFields)) this.$set(this.prj.customerFields, "hidePrices", this.$store.state.progeo.progeoHidePrices);
                if (!("sellerInfo" in this.prj.customerFields)) this.$set(this.prj.customerFields, "sellerInfo", "");
                if (!("shopIdCleaned" in this.prj.customerFields)) this.$set(this.prj.customerFields, "shopIdCleaned", null);
                if (!("discount1" in this.prj.customerFields)) this.$set(this.prj.customerFields, "discount1", this.$store.state.progeo.progeoDiscount1);
                if (!("discount2" in this.prj.customerFields)) this.$set(this.prj.customerFields, "discount2", this.$store.state.progeo.progeoDiscount2);
                if (!("vat" in this.prj.customerFields)) this.$set(this.prj.customerFields, "vat", this.$store.state.progeo.progeoVat);
                if (!("netElementPrice" in this.prj.customerFields)) this.$set(this.prj.customerFields, "netElementPrice", null);
                if (!("shopDiscount" in this.prj.customerFields)) this.$set(this.prj.customerFields, "shopDiscount", this.$store.state.progeo.progeoShopDiscount);
                if (!("userExtraDataHidePrices" in this.prj.customerFields)) this.$set(this.prj.customerFields, "userExtraDataHidePrices", this.$store.state.progeo.progeoUserExtraDataHidePrices);
            },
            viewOffer(id) {
                this.openPrj(id, true);
            },
            openPrj(id, viewoffer = false) {
                let loadPrj = () => {
                    if (localStorage["next_goto"]) delete localStorage["next_goto"];
                    bus.$emit("startLoading", this._trans("Loading project"));
                    this.$store
                        .dispatch("project/load", { id: id })
                        .then(prj => {
                            this._checkOldWalls().then(() => {
                                this.pricesIncrease = prj.pricesIncrease;
                                if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");
                                bus.$emit("stopLoading");
                                this.checkCustomerParams();
                                this.onProjectLoaded(viewoffer);
                            });
                        })
                        .catch(() => {
                            bus.$emit("stopLoading");
                        });
                };

                if (this.prj.isopen) {
                    this.$3cadAsk({
                        title: this._trans("Project not saved"),
                        body: this._trans("Save current project?"),
                        okTitle: this._trans("Yes"),
                        cancelTitle: this._trans("No")
                    })
                        .then(data => {
                            this.savePrj().then(loadPrj);
                        })
                        .catch(mode => {
                            if (mode === 0) loadPrj();
                        });
                } else {
                    loadPrj();
                }
            },
            cloneProjectOld() {
                bus.$emit("startLoading", this._trans("Cloning project"));
                return new Promise((resolve, reject) => {
                    if (this.canSavePrj) {
                        this.$store.dispatch("project/save", { clone: true }).then(res => {
                            this.$store.commit("resetLoading");
                            bus.$emit("savedPrj");
                            resolve();
                        });
                    } else {
                        this.prj.id = 0;
                        this.$store.dispatch("project/save", {}).then(() => {
                            this.$store.dispatch("project/setStatus", { prjId: this.prj.id, status: "SELLER DESIGN" }).then(() => {
                                this.$store.commit("resetLoading");
                                bus.$emit("savedPrj");
                                resolve();
                            });
                        });
                    }
                });
            },
            revalProject() {
                const _this = this;
                return new Promise(resolve => {
                    RevalPrj.reval(_this.prj, perc => {
                        bus.$emit("startLoading", _this._trans("Revaluate project"), perc);
                    })
                        .then(() => {
                            bus.$emit("stopLoading");
                            resolve();
                        })
                        .catch(err => {
                            bus.$emit("stopLoading");
                            resolve();
                        });
                });
            },
            close() {
                this.$refs.modal.hide();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .no-menu {
        padding-top: 0;
    }

    .mid-menu {
        padding-top: 70px;
        @include media-breakpoint-down(md) {
        }
    }

    .full-menu {
        padding-top: 8.15rem;
        @include media-breakpoint-down(md) {
            padding-top: 5.15rem;
        }
    }

    .username {
        position: absolute;
        right: 20px;
        bottom: 5px;
    }

    .catalog {
        position: absolute;
        right: 200px;
        width: 120px;
        height: 38px;
        color: $white;
        border: 0;
        background-color: $color;
    }

    .catalogoption {
        font-size: 0.8em;
        font-weight: normal;
    }

    .body {
    }

    .close {
        z-index: 10;
        padding-top: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/custom/progeo/start.vue